(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sparbude-pack-choice"]) return;
  try {
    
(() => {
  const W={
    'sb-pack-einzelartikel':{label:'Einzelartikel',cls:'single',order:1},
    'sb-pack-spar-sets':{label:'Spar-Set',cls:'set',order:2},
    'sb-pack-gebinde':{label:'Gebinde',cls:'case',order:3}
  };
  const world=t=>Object.keys(W).find(x=>(t||[]).includes(x))||'';
  const path=u=>{try{return new URL(u,location.origin).pathname}catch(_){return u}};
  const ean=c=>{
    const b=String(c.barcode||'').replace(/\D/g,'');
    if(b.length>=8&&b.length<=14)return b;
    const m=String(c.description||'').match(/(?:GTIN\s*\(EAN\)|EAN)\s*:?\s*(\d{8,14})/i);
    return m?m[1]:'';
  };
  const baseTitle=s=>String(s||'')
    .replace(/^\s*\d+\s*[x×]\s*/i,'')
    .replace(/\s*\(\s*\d+\s*[x×][^)]*\)\s*$/i,'')
    .replace(/\s+/g,' ').trim();
  const qty=(s,t,w)=>{
    if(w==='sb-pack-einzelartikel')return 1;
    const v=String(s||'');
    for(const r of [/^\s*(\d{1,3})\s*[x×]/i,/(?:^|[\s(–-])(\d{1,3})\s*[x×]\s*\d/i,/\b(\d{1,3})er[- ]?(?:pack|set)\b/i]){
      const m=v.match(r); if(m)return Math.max(1,parseInt(m[1],10)||1);
    }
    if((t||[]).some(x=>/dreierset/i.test(x)))return 3;
    return 1;
  };
  const money=(v,c)=>new Intl.NumberFormat('de-DE',{style:'currency',currency:c||'EUR'}).format(Number(v)||0);
  const search=async q=>{
    const root=window.Shopify?.routes?.root||'/';
    const u=new URL(root+'search/suggest.json',location.origin);
    u.searchParams.set('q',q);
    u.searchParams.set('resources[type]','product');
    u.searchParams.set('resources[limit]','10');
    u.searchParams.set('resources[options][unavailable_products]','hide');
    const r=await fetch(u,{credentials:'same-origin'});
    if(!r.ok)throw new Error();
    const j=await r.json();
    return j?.resources?.results?.products||[];
  };
  const score=(p,c,code)=>{
    let s=0;
    if(code&&String(p.body||'').includes(code))s+=100;
    if(String(p.vendor||'').toLowerCase()===String(c.vendor||'').toLowerCase())s+=20;
    const a=baseTitle(c.title).toLowerCase(),b=baseTitle(p.title).toLowerCase();
    if(a===b)s+=50;
    else a.split(/\s+/).filter(x=>x.length>2).forEach(x=>{if(b.includes(x))s+=3});
    return s;
  };
  const card=(i,single,currency,current)=>{
    const meta=W[i.world],q=qty(i.title,i.tags,i.world),unit=i.price/q,ref=single&&q>1?single*q:0;
    const save=ref>0?Math.round((1-i.price/ref)*1000)/10:0;
    const a=document.createElement('a');
    a.className='sb-packchoice__option sb-packchoice__option--'+meta.cls+(path(i.url)===path(current)?' is-current':'');
    a.href=i.url;
    const top=document.createElement('div');top.className='sb-packchoice__optiontop';
    const badge=document.createElement('span');badge.className='sb-packchoice__badge';badge.textContent=meta.label;top.appendChild(badge);
    if(path(i.url)===path(current)){const x=document.createElement('span');x.className='sb-packchoice__current';x.textContent='Du bist hier';top.appendChild(x)}
    const media=document.createElement('div');media.className='sb-packchoice__media';
    if(i.image){const img=document.createElement('img');img.src=i.image;img.alt='';img.loading='lazy';media.appendChild(img)}
    const body=document.createElement('div');body.className='sb-packchoice__body';
    const ql=document.createElement('strong');ql.className='sb-packchoice__qty';ql.textContent=q>1?q+' Stück':'1 Stück';
    const title=document.createElement('span');title.className='sb-packchoice__title';title.textContent=i.title;
    const price=document.createElement('div');price.className='sb-packchoice__price';
    const pb=document.createElement('b');pb.textContent=money(i.price,currency);
    const pu=document.createElement('span');pu.textContent=money(unit,currency)+' / Stück';
    price.append(pb,pu);body.append(ql,title,price);
    if(save>=1){const sv=document.createElement('span');sv.className='sb-packchoice__saving';sv.textContent=save.toLocaleString('de-DE',{maximumFractionDigits:1})+' % Ersparnis';body.appendChild(sv)}
    const ar=document.createElement('span');ar.className='sb-packchoice__arrow';ar.textContent='→';
    a.append(top,media,body,ar);return{el:a,save};
  };

  document.querySelectorAll('[data-sb-pack-choice]').forEach(async sec=>{
    const ctxEl=sec.querySelector('[data-sb-pack-context]'),out=sec.querySelector('[data-sb-pack-options]');
    if(!ctxEl||!out)return;
    let c;try{c=JSON.parse(ctxEl.textContent)}catch(_){return}
    const cw=world(c.tags);if(!cw)return;
    const code=ean(c),queries=[code,[c.vendor,baseTitle(c.title)].filter(Boolean).join(' ')].filter(Boolean);
    let found=[];
    for(const q of queries){
      try{found=found.concat(await search(q))}catch(_){}
      if(new Set(found.map(p=>world(p.tags)).filter(Boolean)).size>=2)break;
    }
    const map=new Map();
    found.forEach(p=>{
      const w=world(p.tags);if(!w||!p.url)return;
      const k=path(p.url),sc=score(p,c,code),old=map.get(k);
      const item={score:sc,world:w,title:p.title||'',url:k,tags:p.tags||[],image:p.featured_image?.url||p.image||'',price:parseFloat(p.price||p.price_min||0)};
      if(!old||sc>old.score)map.set(k,item);
    });
    map.set(path(c.url),{score:999,world:cw,title:c.title,url:path(c.url),tags:c.tags||[],image:c.image||'',price:Number(c.priceCents||0)/100});
    const all=[...map.values()].filter(x=>x.price>0);
    const best=[];
    Object.keys(W).forEach(w=>{
      const arr=all.filter(x=>x.world===w).sort((a,b)=>b.score-a.score);
      if(arr[0])best.push(arr[0]);
    });
    const single=best.find(x=>x.world==='sb-pack-einzelartikel');
    const singlePrice=single?.price||(cw==='sb-pack-einzelartikel'?Number(c.priceCents||0)/100:0);
    if(best.length<2||!singlePrice)return;
    best.sort((a,b)=>W[a.world].order-W[b.world].order);
    let saving=false;
    best.forEach(i=>{const built=card(i,singlePrice,c.currency,c.url);if(built.save>=1)saving=true;out.appendChild(built.el)});
    if(saving)sec.querySelector('[data-sb-pack-note]').hidden=false;
    sec.hidden=false;
  });
})();
/* SPARBUDE: Ergänzung für sections/sparbude-pack-choice.liquid
   Diesen gesamten Block vor dem Ende des vorhandenen JavaScript-Blocks einfügen.
   Die bestehende Logik für Menge, Stückpreis und Rabatte bleibt unverändert. */
(() => {
  const money = (value, currency) =>
    new Intl.NumberFormat('de-DE', {
      style: 'currency', currency: currency || 'EUR'
    }).format(value);

  const unitFactor = unit => {
    const factors = { mg: 0.000001, g: 0.001, kg: 1,
      ml: 0.001, cl: 0.01, l: 1, item: 1, m: 1, cm: 0.01 };
    return factors[String(unit || '').toLowerCase()] ?? null;
  };

  const lookup = async href => {
    const url = new URL(href, location.origin);
    if (!url.pathname.includes('/products/')) return null;
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';

    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return null;
    const product = await response.json();
    const variant = (product.variants || []).find(v => v.available) ||
      product.variants?.[0];
    const measurement = variant?.unit_price_measurement;
    if (!measurement?.reference_unit) return null;

    let cents = Number(variant.unit_price);
    if (!(cents > 0)) {
      // Shopify-Mengenmessung als Fallback statt Gewicht aus Produkttiteln zu raten.
      const quantityFactor = unitFactor(measurement.quantity_unit);
      const referenceFactor = unitFactor(measurement.reference_unit);
      const quantity = Number(measurement.quantity_value) * quantityFactor;
      const reference = Number(measurement.reference_value || 1) * referenceFactor;
      if (!(quantity > 0 && reference > 0)) return null;
      cents = Number(variant.price) * reference / quantity;
    }
    if (!(cents > 0)) return null;

    const referenceValue = Number(measurement.reference_value || 1);
    const denominator = (referenceValue === 1 ? '' : `${referenceValue} `) +
      measurement.reference_unit;
    return money(cents / 100, window.Shopify?.currency?.active || 'EUR') +
      ' / ' + denominator;
  };

  const enhance = card => {
    if (card.dataset.sbGrundpreisProcessed === '1') return;
    card.dataset.sbGrundpreisProcessed = '1';
    const priceBox = card.querySelector('.sb-packchoice__price');
    if (!priceBox) return;
    lookup(card.href).then(text => {
      if (!text || !card.isConnected) return;
      const basePrice = document.createElement('span');
      basePrice.className = 'sb-packchoice__grundpreis';
      basePrice.textContent = 'Grundpreis: ' + text;
      priceBox.appendChild(basePrice);
    }).catch(() => {});
  };

  const css = document.createElement('style');
  css.textContent = `.sb-packchoice__price .sb-packchoice__grundpreis {
    display:block; margin-top:4px; font-size:10px; line-height:1.4;
    color:#5f6773; font-weight:500;
  }`;
  document.head.appendChild(css);

  document.querySelectorAll('[data-sb-pack-options]').forEach(options => {
    const apply = () => options.querySelectorAll('.sb-packchoice__option').forEach(enhance);
    new MutationObserver(apply).observe(options, { childList: true });
    apply();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
